import { createContext, useContext } from 'react';

import type { SessionDetailDto } from './schemas/sessionSchemas';

// When present, session step components run in the ANONYMOUS public-link mode:
// useVerifyStep posts to the token-authorized public endpoint instead of the
// tenant-scoped one, and pushes the updated session back via onSessionUpdate
// (there is no react-query tenant cache to update in public mode).
export interface PublicRunContextValue {
  // The per-session run token. Always present: a public run only starts after the
  // applicant's mobile number is verified, which is what creates the session (see
  // MobileVerificationGate) — so there is no session-less submit path any more.
  token: string;
  onSessionUpdate: (session: SessionDetailDto) => void;
}

export const PublicRunContext = createContext<PublicRunContextValue | null>(null);

export function usePublicRun(): PublicRunContextValue | null {
  return useContext(PublicRunContext);
}
